export { Terminal3 as default } from './Terminal3';
